"use client";

// Crash/error boundary fallback (QA-SHARED-1: crash → fallback, не пустой
// экран/зависание). Тексты и кнопка — инъекция: message обязателен, кнопка
// retry — через renderAction (по умолчанию нативный, см. action-renderer).
import { renderDefaultAction, type RenderAction } from "./action-renderer";

export interface ErrorFallbackProps {
  /** Текст ошибки — обязателен (локализация на стороне потребителя). */
  message: string;
  /** Лейбл кнопки retry — используется только если передан onRetry. */
  retryLabel?: string;
  onRetry?: () => void;
  /** Рендер кнопки retry (по умолчанию — нативный <button>). */
  renderAction?: RenderAction;
  "data-testid"?: string;
}

export function ErrorFallback({
  message,
  retryLabel,
  onRetry,
  renderAction = renderDefaultAction,
  "data-testid": testId,
}: ErrorFallbackProps) {
  return (
    <div role="alert" data-testid={testId} className="flex flex-col items-center justify-center gap-4 p-6 text-center">
      <p className="whitespace-pre-line text-base text-text-primary">{message}</p>
      {onRetry
        ? renderAction({
            variant: "primary",
            onClick: onRetry,
            "data-testid": "error-retry",
            children: retryLabel ?? "",
          })
        : null}
    </div>
  );
}
